import axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Spinner from "../Components/Spinner";
import { API_URL } from "../config";
import "../Styles/ContactUs.css";

function ContactUs() {
  const [email, setEmail] = useState("");
  const [contentType, setContentType] = useState("");
  const [content, setContent] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);

      // Send email first
      await axios.post(`${API_URL}/contact-us-email`, {
        email,
        contentType,
        content,
      });

      // Then try to store in database
      try {
        await axios.post(`${API_URL}/contact-us`, {
          email,
          contentType,
          content,
        });
        setMessage("Message sent successfully and stored");
      } catch (dbError) {
        console.error("Database error:", dbError);
        setMessage("Message sent successfully but couldn't store in database");
      }

      // Reset form fields regardless of database success
      setEmail("");
      setContentType("");
      setContent("");
    } catch (emailError) {
      console.error("Error sending message:", emailError);
      setMessage("Failed to send message. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="contactus-page">
      <Navbar />

      {/* New Top Section */}
      <div className="contactus-top-section">
        <h2>Want Exclusive Access?</h2>
        <p>
        <strong> Gain exclusive access </strong> to RoboFication’s cutting-edge tools for systems
          analysis and requirement generation. <strong>  Contact us </strong>  today and be a part of
          shaping the future of safety-critical engineering.
        </p>
        <Link to="/products" className="explore-link">
          Explore Robo Products Now.
        </Link>
      </div>

      <div class="contactus-header">
        <h2>Contact Us</h2>
      </div>

      {/* Contact Us Form */}
      <div className="contactus-form">
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <select
              value={contentType}
              onChange={(e) => setContentType(e.target.value)}
              required
            >
              <option value="">Select Type</option>
              <option value="Product Access">Product Access</option>
              <option value="Bug Report">Bug Report</option>
              <option value="Recommendation">Recommendation</option>
              <option value="Enterprise Request">Enterprise Request</option>
              <option value="Support">Support</option>
            </select>
          </div>
          <div className="input-group">
            <textarea
              placeholder="Your Message"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              required
            />
          </div>

          {/* Disclaimer message below the input fields */}
          <p className="disclaimer-message">
            *By submitting this form you agree to receive email communication from us and understand 
            that your contact information will be stored with us.
          </p>

          <div className="input-group">
            {isLoading ? (
              <span className="spinner-wrapper">
                <Spinner />
              </span>
            ) : (
              <button type="submit">Submit</button>
            )}
          </div>
        </form>
        {message ? <p>{message}</p> : <p></p>}
      </div>
      <Footer />
    </div>
  );
}

export default ContactUs;
